module.exports = __webpack_public_path__ + "static/media/mission_malamal.09d0f357.jpeg";